module.exports = {

    props: {
        project: {
            type: Object,
            required: true,
        }
    },

    methods: {
        openTest(form) {
            this.redirectTo(`/projects/${this.project.slug}/forms/${form.slug}`)
        },
    }
}

